import { ErrorCode, ProblemDetail } from '@endion/types';

export const GENERIC_ERROR_MESSAGE = 'Ocurrió un error inesperado';

export const ERROR_MESSAGES: Partial<Record<ErrorCode, string>> = {
  APP_MAINTENANCE_MODE: 'Estamos realizando tareas de mantenimiento',
  CANNOT_PARSE_REDIS_SESSION: GENERIC_ERROR_MESSAGE,
  INVALID_DTO: GENERIC_ERROR_MESSAGE,
  NO_MESSAGE_FOUND: GENERIC_ERROR_MESSAGE,
  PROCESSING_MESSAGE_FAILED: 'Ocurrió un error al procesar el mensaje',
  INVALID_VERIFY_TOKEN: 'El token de verificación es inválido',
  NO_CONVERSATION_FOUND: 'No se encontró ninguna conversacion',
  CONVERSATION_EXPIRED: 'La conversación ha expirado',
  LLM_ERROR: 'Ocurrió un error al procesar el mensaje. Intentá enviando nuevamente el mensaje.',
  STREAMING_ERROR: 'Ocurrió un error al procesar el mensaje. Intentá enviando nuevamente el mensaje.',
};

export function responseAsProblemDetail(data: unknown): data is ProblemDetail {
  if (data !== null && typeof data === 'object' && 'code' in data && 'title' in data && 'type' in data) {
    return true;
  }
  return false;
}

export function findServerSideSchemaValidationErrorPaths(problem: ProblemDetail): Array<string> {
  try {
    const detail = JSON.parse(problem.detail || 'null');
    if (Array.isArray(detail)) {
      return detail.map((item) => (item.path || []).join('.'));
    }
    return [];
  } catch (e) {
    return [];
  }
}
